export default __webpack_public_path__ + "static/media/facebook.4737f6c3.svg";